function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Editor editor for large blocks of code
 */
import React, { Component } from 'react';
import classNames from 'classnames';
import * as monaco from 'monaco-editor';
import { assertNotNull } from '@deephaven/utils';
import MonacoUtils from "../monaco/MonacoUtils.js";
import "./Editor.css";
import { jsx as _jsx } from "react/jsx-runtime";
class Editor extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "editor", void 0);
    this.handleResize = this.handleResize.bind(this);
    this.container = null;
    this.state = {};
  }
  componentDidMount() {
    this.initEditor();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.destroyEditor();
  }
  setLanguage(language) {
    if (this.editor) {
      var model = this.editor.getModel();
      assertNotNull(model);
      monaco.editor.setModelLanguage(model, language);
    }
  }
  handleResize() {
    this.updateDimensions();
  }
  toggleFind() {
    if (this.editor) {
      // The actions.find action can no longer be triggered when the editor is not in focus, with monaco 0.22.x.
      // As a workaround, just focus the editor before triggering the action
      // https://github.com/microsoft/monaco-editor/issues/2355
      this.editor.focus();
      this.editor.trigger('toggleFind', 'actions.find', undefined);
    }
  }
  updateDimensions() {
    var _this$editor;
    (_this$editor = this.editor) === null || _this$editor === void 0 || _this$editor.layout();
  }
  initEditor() {
    var onEditorInitialized = this.props.onEditorInitialized;
    var settings = this.props.settings;
    settings = _objectSpread({
      copyWithSyntaxHighlighting: false,
      fixedOverflowWidgets: true,
      folding: false,
      fontFamily: 'Fira Mono',
      glyphMargin: false,
      language: "python",
      lineNumbersMinChars: 3,
      minimap: {
        enabled: false
      },
      scrollBeyondLastLine: false,
      tabCompletion: 'on',
      value: '',
      wordWrap: 'off',
      links: true,
      autoClosingBrackets: 'beforeWhitespace'
    }, settings);
    assertNotNull(this.container);
    this.editor = monaco.editor.create(this.container, settings);
    this.editor.addAction({
      id: 'find',
      label: 'Find',
      keybindings: [
      // eslint-disable-next-line no-bitwise
      monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyF],
      precondition: undefined,
      keybindingContext: undefined,
      contextMenuGroupId: 'navigation',
      contextMenuOrder: 1.0,
      run: () => {
        this.toggleFind();
      }
    });
    this.editor.layout();
    monaco.languages.registerLinkProvider('plaintext', {
      provideLinks: MonacoUtils.provideLinks
    });
    onEditorInitialized(this.editor);
  }
  destroyEditor() {
    var onEditorWillDestroy = this.props.onEditorWillDestroy;
    assertNotNull(this.editor);
    onEditorWillDestroy(this.editor);
    this.editor.dispose();
    this.editor = undefined;
  }
  render() {
    var className = this.props.className;
    return /*#__PURE__*/_jsx("div", {
      className: classNames('editor-container', className),
      ref: container => {
        this.container = container;
      }
    });
  }
}
_defineProperty(Editor, "defaultProps", {
  className: 'fill-parent-absolute',
  onEditorInitialized: () => undefined,
  onEditorWillDestroy: () => undefined,
  settings: {}
});
export default Editor;
//# sourceMappingURL=Editor.js.map